import "./Home.module.css";
import Navigation from "@/reusable_sections/Header";
import Shield from "./sections/Shield";
import Partners from "./sections/Partners";
import Defense from "./sections/Defense";
import Advantage from "./sections/Advantage";
import Roadmap from "./sections/Roadmap";
import Secure from "./sections/Secure";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Navigation />
      <Shield />
      <Partners />
      <Defense />
      <Advantage />
      <Roadmap />
      <Secure />
      <Footer />
    </div>;
}